import { render, staticRenderFns } from "./ClassicProductView.vue?vue&type=template&id=c6b9187a&"
import script from "./ClassicProductView.vue?vue&type=script&lang=js&"
export * from "./ClassicProductView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports